import { DocumentType } from '@consigli/types';
import { useCallback } from 'react';
import { useLazyGetBuildingPackageFilesQuery } from '../api';
import { useDownloadFilesAsZip } from './use-download-files-as-zip';
/**
 * Hook for downloading all files from a building package as a ZIP file
 */
export const useDownloadBuildingPackageZip = () => {
    const [getBuildingPackageFiles] = useLazyGetBuildingPackageFilesQuery();
    const { downloadFileZip, isDownloading } = useDownloadFilesAsZip('building-package', false);
    const downloadBuildingPackageAsZip = useCallback(async (buildingPackage, projectId) => {
        try {
            const result = await getBuildingPackageFiles({
                projectId,
                buildingPackageId: buildingPackage.id,
                page: 'all',
            }).unwrap();
            const documents = result.results.map((file) => ({
                id: file.id,
                name: file.originalFilename || file.filename,
                type: DocumentType.FILE,
                extension: file.filenameExtension || '',
                projectId: file.projectId,
                fileUrl: file.fileUrl,
                downloadUrl: file.fileUrl,
            }));
            await downloadFileZip(documents);
        }
        catch (error) {
            console.error('Error downloading building package as ZIP:', error);
            throw error;
        }
    }, [getBuildingPackageFiles, downloadFileZip]);
    return {
        downloadBuildingPackageAsZip,
        isDownloading,
    };
};
